import canUserManage from '../../organisations/can/manage';
import manage from './manage';

/**
 * @param {Object} me
 * @param {Object} permissions
 * @param {Boolean} isScenario
 * @param {Boolean} isHistorical
 * @returns {Boolean}
 */
export default function restore(me, permissions, isScenario, isHistorical) {
  const canManageOrganisation = canUserManage(me, permissions);
  const canManage = isScenario
    ? manage(me, permissions)
    : canManageOrganisation;
  return isHistorical && canManage;
}
